import {
  closeManagerPanel,
  openManagerPanel,
  showDevicePanels,
  ManagerPanelState,
} from '../utils/ManagerPanelNavigation';

/** Initial drawer panel state (EN-1848: and the page closing a panel returns to). */
export function managerPanelState(): ManagerPanelState {
  return {
    showPigRunManager: false,
    showDeviceInfo: true,
    showDeviceTable: true,
    showReportManager: false,
    showDownloadManager: false,
    showBroadcastCommands: false,
    showStreamManager: false,
    managerReturnTo: 'device',
  };
}

/**
 * Root mutations that switch the left drawer between the device list, the Pig
 * Run Manager and the Report / Download / Broadcast / Stream manager panels.
 */
export const managerPanelMutations = {
  SHOW_PIG_RUN_MANAGER(state: any, payload?: any) {
    openManagerPanel(state, 'pigRunManager');
  },

  HIDE_PIG_RUN_MANAGER(state: any, payload?: any) {
    showDevicePanels(state);
  },

  SHOW_REPORT_MANAGER(state: any, payload?: any) {
    openManagerPanel(state, 'reportManager');
    state.reportManagerPreselectedPigRunId = payload?.pigRunId ?? null;
  },

  SHOW_DOWNLOAD_MANAGER(state: any, payload?: any) {
    openManagerPanel(state, 'downloadManager');
  },

  SHOW_BROADCAST_COMMANDS(state: any, payload?: any) {
    openManagerPanel(state, 'broadcastCommands');
  },

  SHOW_STREAM_MANAGER(state: any) {
    openManagerPanel(state, 'streamManager');
  },

  // EN-1848: closing the Report Manager, Download Manager, Broadcast Commands
  // or Stream Manager returns to the page it was opened from. Landing on the
  // device page also drops a completed run picked in the Report Manager, so
  // the map's Tracksheet button does not keep showing it (the Pig Run Manager
  // keeps it, as its own close clears it).
  CLOSE_MANAGER_PANEL(state: any) {
    if (closeManagerPanel(state) === 'device' && state.pigRun) {
      state.pigRun.selectedCompletedPigRunId = null;
    }
  },

  HIDE_STREAM_MANAGER(state: any) {
    if (closeManagerPanel(state) === 'device' && state.pigRun) {
      state.pigRun.selectedCompletedPigRunId = null;
    }
  },
};

/** Root actions for the manager panels. */
export const managerPanelActions = {
  closeManagerPanel(context: {
    commit: (type: string, payload?: unknown) => void;
  }) {
    context.commit('CLOSE_MANAGER_PANEL');
  },
};
